import SalesGroup from './SalesGroup'
import listSalesGroups from './gql/listSalesGroups'
import getSalesGroup from './gql/getSalesGroup'
import updateSalesGroup from './gql/updateSalesGroup'
import createSalesGroup from './gql/createSalesGroup'
import columns from './sideListColumns'
import { INIT_QUERY_PARAMS } from 'config/consts'

const sections = t => ([{
	label: t('options_section.sub_sections.sales_groups'),
	link: 'umsatzgruppen',
	listQuery: listSalesGroups,
	initialQueryVariables: { filter: {}, params: { ...INIT_QUERY_PARAMS.defaultParams, offset: 0 } },
	itemQuery: getSalesGroup,
	createMutation: createSalesGroup,
	addNewRecord: true,
	requiredFields: ['name', 'acountNum'],
	typename: 'SalesGroup',
	columns: columns(t),
	subsections: [{
		link: '',
		component: SalesGroup,
		updateMutation: updateSalesGroup,
		fields: ['acountNum', 'name', 'discount', 'accountingReduced', 'accountingNormal', 'accountingZeroPercent']
	}],
	sideListProps: {
		datatableProps: {
			defaultSorted: [{
				id: 'acountNum'
			}]
		}
	}
}])

export default sections
